import { UserStatus } from "@generated/CurrentUser_Query.graphql";
import { StartTreeConfigType } from "@generated/NavigateDirectToQuestionsAdvanceTreeButton_LearnOpportunityV2Fragment.graphql";
import { selectTooltipBasedOnGlobalUserStatus } from "./selectTooltipBasedOnGlobalUserStatus";

export const selectTooltipStartConfigType = (
	reasonConfigTypes: readonly StartTreeConfigType[] | undefined,
	globalUserStatus: UserStatus | undefined,
) => {
	if (reasonConfigTypes?.includes("StartTree_SpecificUserRolesCan")) {
		return "Die Bearbeitung des Moduls ist nicht für ihre Berufsgruppe vorgesehen.";
	} else if (reasonConfigTypes?.includes("StartTree_SpecificUserStatusesCan")) {
		return selectTooltipBasedOnGlobalUserStatus(globalUserStatus);
	} else {
		return "Dieser Service steht Ihnen nicht zur Verfügung.";
	}
};
